var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteEmployee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(0 -0.108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 20,
    height: 20,
    transform: "translate(0 0.108)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(3.81 1.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1731.988,1890.069h-10.034a.254.254,0,0,0-.257.249v.877h8.079a1.18,1.18,0,0,1,1.2,1.158v11.892h1.015a.253.253,0,0,0,.257-.249v-13.678A.253.253,0,0,0,1731.988,1890.069Z",
    transform: "translate(-1719.483 -1890.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1720.223,1901.266h-10.034a.253.253,0,0,0-.257.249v13.678a.254.254,0,0,0,.257.249h10.034a.253.253,0,0,0,.257-.249v-13.678A.253.253,0,0,0,1720.223,1901.266Zm-5.734,1.382a1.587,1.587,0,0,1,.556-.129.524.524,0,0,0,.084-.016h.063l.221.029a1.535,1.535,0,0,1,1.367,1.257,1.432,1.432,0,0,1-1.2,1.722,1.819,1.819,0,0,1-1.291-.261,1.364,1.364,0,0,1-.666-.979A1.509,1.509,0,0,1,1714.488,1902.648Zm-2.128,6.14a2.847,2.847,0,0,1,5.691,0v1.093h-5.691Zm-.686,3.02a.464.464,0,0,1,.464-.391h6.136a.455.455,0,1,1,0,.909h-6.136a.471.471,0,0,1-.47-.454A.473.473,0,0,1,1711.674,1911.807Zm7.07,1.843a.437.437,0,0,1-.056.211.47.47,0,0,1-.414.244h-6.136a.463.463,0,0,1-.47-.455.435.435,0,0,1,.063-.222.47.47,0,0,1,.408-.232h6.136a.473.473,0,0,1,.4.211A.44.44,0,0,1,1718.744,1913.65Z",
    transform: "translate(-1709.931 -1899.16)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEmployee);
export default __webpack_public_path__ + "static/media/white_employee.b7ed6c5df1abeb4f653783198445fc9f.svg";
export { ForwardRef as ReactComponent };